import React from 'react';

import { LandingPage } from './landing/LandingPage';

export const HomePage: React.FC = () => <LandingPage />;

export default HomePage;
